import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Validator from 'validatorjs';

import { Http } from '../../../../support';
import ModalResult from '../../../../facturotopia/ModalResult';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ResponseError from '../../../../shared/responses/ResponseError';
import EmisorFiscalCredentialsForm from './EmisorFiscalCredentialsForm';
import EmisorFiscalCredentialslInfo from './EmisorFiscalCredentialslInfo';

class EmisorFiscalCredentials extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { type } = this.props;
    const keyPairType = type.toString().toLowerCase();

    const rules = {
      [`${keyPairType}_key`]: ['required'],
      [`${keyPairType}_cer`]: ['required'],
      [`${keyPairType}_password`]: ['required', 'min:4']
    }

    this.state = {
      busy: false,
      validator: new Validator({}, rules),
      rules,
      confirmed: false,
      terms_accepted: false,
    };
  }

  validate(data) {
    const validator = new Validator(data, this.state.rules);

    validator.check();

    this.setState({
      validator,
      isValid:  validator.passes()
    });

    return validator;
  }

  handleOnChange = (event) => {
    const { confirmed } = this.state;

    const data = {
      ...this.props.data,
      ...event.data
    }

    const validator = this.validate(data.certificados);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid:  validator.passes() && !!confirmed
    });
  }

  handleOnFiscalCredentialsChange = (event) => {
    const { type } = this.props;
    const extra = type.toLowerCase() === 'csd'
      ? {
        rfc: undefined,
        razon_social: undefined,
        regimen: undefined
      }
      : {};

    const data = {
      ...this.props.data.certificados,
      ...event.data
    }

    this.handleOnChange({
      data: {
        certificados: data,
        ...extra
      }
    });
  }

  handleCsdVerification = async () => {
    const { confirm, data: { certificados = {}}, external = false } = this.props;

    this.setState({
      busy: true
    });

    try {
      const data = {
        csd_key: certificados.csd_key && certificados.csd_key.value.content,
        csd_cer: certificados.csd_cer && certificados.csd_cer.value.content,
        csd_password: certificados.csd_password,
        fiel_key: certificados.fiel_key && certificados.fiel_key.value.content,
        fiel_cer: certificados.fiel_cer && certificados.fiel_cer.value.content,
        fiel_password: certificados.fiel_password
      }

      const url = !!external ? 'ext/tools/certificates': 'api/tools/certificates';
      const response = await Http.post(url, data);

      this.handleOnChange({
        data: {
          razon_social: response.data.razon_social,
          rfc: response.data.rfc
        },
        confirming: true,
      });

      if (confirm !== false) {
        this.setState({
          ...this.state,
          confirmed: true,
          result: response
        });
      } else {
        setTimeout(() => this.handleOnAction('confirm') );
      }
    } catch (error) {
      this.setState({
        ...this.state,
        error: error.data || error
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnTermsAcceptanceChange = (value) => {
    this.setState({
      ...this.state,
      terms_accepted: value
    });
  }

  handleOnErrorAction = (action) => {
    this.setState({
      ...this.state,
      error: undefined,
      result: undefined
    });
  }

  handleOnAction = (action) => {
    this.setState({
      ...this.state,
      error: undefined,
      result: undefined,
      confirmed: action === 'confirm'
    }, () => {
      if (action === 'confirm') {
        this.handleOnChange({
          data: {}
        });
      } else {
        this.handleOnChange({
          data: {
            certificados: {},
            razon_social: undefined,
            regimen: undefined,
            rfc: undefined
          }
        });
      }
    });
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnErrorAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result, terms_accepted } = this.state;
    const { data, type, terms } = this.props;

    const Terms = terms;

    return (
      <div className="result-container">
        <ModalResult status="success"
          title={ type === 'CSD' ? `${type} verificado` : `${type} verificada` }
          subtitle={ result.message }
          extra={ <>
              <Button type="button"
                variant="secondary"
                className="mr-2"
                onClick={ this.handleOnAction.bind(this, 'reset') }
              >
                { type === 'CSD' ? 'Subir otro CSD' : 'Subir otra FIEL' }
              </Button>
              <Button type="button"
                disabled={ !!terms && !terms_accepted  }
                onClick={ this.handleOnAction.bind(this, 'confirm') }
              >
                Usar { type }
              </Button>
            </>
          }
        >
          <EmisorFiscalCredentialslInfo data={ data } />

          { terms && <Terms onTermsAcceptanceChange={ this.handleOnTermsAcceptanceChange } /> }

        </ModalResult>
      </div>
    );
  }

  render() {
    const { error, result, busy, isValid } = this.state;
    const { type, inputs = {}, data } = this.props;

    return (
      <>
        { !!error && this.renderError() }

        { !!result && this.renderResult() }

        <EmisorFiscalCredentialsForm
          type={ type }
          data={ data.certificados || {} }
          inputs={ inputs }
          onFormDataChange={ this.handleOnFiscalCredentialsChange }
        />

        <LoadingButton type="button"
          variant="secondary"
          loading={ busy }
          disabled={ !isValid }
          onClick={ this.handleCsdVerification }
        >
          { busy ? 'Validando...' : `Validar ${type}` }
        </LoadingButton>
      </>
    )
  }
}

export default EmisorFiscalCredentials;